module.exports = __webpack_public_path__ + "static/media/WetlandRide.350461d9.jpg";